import React from "react";
import MatchThumbnail from "./MatchThumbnail";
import "./MatchThumbnail.scss";

export { MatchThumbnail };

export const MemoizedMatchThumbnail = React.memo(MatchThumbnail);
